<template>
  <footer class="w-full py-8 bg-white/80 border-t border-primary/10">
    <div class="max-w-6xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-4 text-gray-500 text-sm">
      <div>
        &copy; {{ new Date().getFullYear() }} TrendzTube. Powered by YouTube trend data.
      </div>
      <div class="flex gap-4">
        <router-link to="/privacy" class="hover:text-primary font-medium transition">
          Privacy Policy
        </router-link>
        <router-link to="/terms" class="hover:text-primary font-medium transition">
          Terms of Service
        </router-link>
        <a :href="getContactMailto()" class="hover:text-primary font-medium transition" target="_blank">Contact</a>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'AppFooter',
  computed: {
    ...mapState(['user', 'profile'])
  },
  methods: {
    getContactMailto() {
      let subject = encodeURIComponent('Trendztube Support Request');
      let body = '';
      if (this.user) {
        body =
          `Hi Trendztube Support,%0D%0A` +
          `I'm ${this.user.email},%0D%0A` +
          `My plan: ${this.profile?.plan?.name || 'Unknown'}%0D%0A` +
          `Please assist me with ...%0D%0A`;
      } else {
        body =
          `Hi Trendztube,%0D%0A` +
          `I'm Tyrese, I would like assistance with ...%0D%0A`;
      }
      return `mailto:tyteapps@gmail.com?subject=${subject}&body=${body}`;
    }
  }
};
</script>
